import { render, staticRenderFns } from "./DashboardWorldRemit.vue?vue&type=template&id=e3e15d54&scoped=true"
import script from "./DashboardWorldRemit.vue?vue&type=script&lang=js"
export * from "./DashboardWorldRemit.vue?vue&type=script&lang=js"
import style0 from "./DashboardWorldRemit.vue?vue&type=style&index=0&id=e3e15d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e15d54",
  null
  
)

export default component.exports